import { render, staticRenderFns } from "./BusinessTab.vue?vue&type=template&id=33f3db40&"
import script from "./BusinessTab.vue?vue&type=script&lang=js&"
export * from "./BusinessTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports